import { render } from "./validationErrorModal.vue?vue&type=template&id=80dc04bc&ts=true"
import script from "./validationErrorModal.vue?vue&type=script&lang=ts"
export * from "./validationErrorModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__